<h1 class="mb-4">Panel organizacji</h1>
<p-tabs scrollable value="0" lazy [class]="'customTab'">
  <p-tablist>
    <p-tab value="0">Dane organizacji</p-tab>
    <p-tab value="1">Przypisani użytkownicy</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      <app-organization-setting-data
        [organization]="applicationContextService.getOrganizationFromContext()!"
      ></app-organization-setting-data>
    </p-tabpanel>
    <p-tabpanel value="1">
      <ng-template #content>
        <app-organization-settings-representatives-table></app-organization-settings-representatives-table>
      </ng-template>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
<div class="flex justify-end mt-5 mr-4">
  <p-button
    type="button"
    aria-label="Wstecz"
    label="Wstecz"
    styleClass="customInfoButton outlined"
    [text]="true"
    (click)="navigateToMainPage()"
  />
</div>
